<template>
  <el-dialog :visible.sync="visible">
    <el-form :model="settingForm"
             ref="settingForm"
             @keyup.enter.native="dataFormSubmitHandle()">
      <el-form-item label="账户级别">
        <el-checkbox-group v-model="userLevelList">
          <el-checkbox label="MIN">迷你</el-checkbox>
          <el-checkbox label="STD">标准</el-checkbox>
          <el-checkbox label="PLA">铂金</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div class="border" style="display:flex;margin-bottom: 20px;">
        未激活账户赠金设置 <div style="color:#0096dc;cursor:pointer;margin-left: 40px" @click="addRules(0)">添加</div>
      </div>
      <rules
        v-for="(item,index) in notActiveRule"
        :key="index"
        :listLiData="item"
        :activeType="0"
        @deleteListData="deleteListData"
      ></rules>

      <div class="border" style="display:flex;margin-bottom: 20px;">
        已激活账户赠金设置 <div style="color:#0096dc;cursor:pointer;margin-left: 40px" @click="addRules(1)">添加</div>
      </div>
      <rules
        v-for="(item,index) in activeRule"
        :key="index"
        :listLiData="item"
        :activeType="1"
        @deleteListData="deleteListData"
      ></rules>

    </el-form>

    <template slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="dataFormSubmitHandle()"
      >确认
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce";
    import rules from "@/views/newmis36/tracker/rules";
    import URL from '@/views/newmis36/util/url';
    import Qs from 'qs';

    export default {
        components: {
            rules
        },
        data() {
            return {
                loading: false,
                visible: false,
                addNum: 0,
                userLevelList: [],
                notActiveRule: [
                ],
                activeRule: [
                ],
                settingForm: {
                    userLevel: "",
                    activeStatus: "",
                    driverType: "",
                    markedWords:"",
                    aountRule: []
                },
            };
        },
        computed: {
        },
        mounted(){
        },
        methods: {
            init(row) {
                this.clearFormData();
                this.visible = true;
                this.$nextTick(() => {
                    this.$refs["settingForm"].resetFields();
                    if (row) {
                        this.getInfo(row);
                    }
                });

            },
            //填充信息
            getInfo(row) {
                if(row.userLevel != null){
                    this.userLevelList = row.userLevel.split(',');
                }else{
                    this.userLevelList = []
                }
                this.notActiveRule = row.aountRule.filter(item => {
                    if (1 == item.activeStatus) {
                        return false;
                    }
                    return true;
                });
                this.activeRule = row.aountRule.filter(item => {
                    if (0 == item.activeStatus) {
                        return false;
                    }
                    return true;
                });
            },
            clearFormData() {
                for (let key in this.settingForm) {
                    if(key=='aountRule'){
                        this.settingForm[key] = [];
                    }else {
                        this.settingForm[key] = "";
                    }
                }
            },
            deleteListData(idIndex) {
                let rules = [];
                if (idIndex.activeType == '0' || idIndex.activeType == 0) {
                    rules = this.notActiveRule;
                } else{
                    rules = this.activeRule;
                }
                let arrIndex = "";
                if (idIndex.index) {
                    for (let i in rules) {
                        if (rules[i].index == idIndex.index) {
                            arrIndex = i;
                        }
                    }
                }
                rules.splice(arrIndex, 1);
            },
            dataChanage(url, option, suc, fail) {
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(
                function () {
                    this.$refs["settingForm"].validate(valid => {
                        console.log(this.settingForm);
                        if (!valid) {
                            return false;
                        }
                        if( this.userLevelList==null || this.userLevelList==undefined || this.userLevelList==''){
                            this.settingForm.userLevel='';
                        }else if(this.userLevelList.length>1){
                            this.settingForm.userLevel=this.userLevelList.join(",");
                        }else{
                            this.settingForm.userLevel=this.userLevelList[0]+"";
                        }
                        this.settingForm.aountRule.push.apply(this.settingForm.aountRule,this.notActiveRule);
                        this.settingForm.aountRule.push.apply(this.settingForm.aountRule,this.activeRule);
                        this.loading = true;
                        //根据是否包含id更新还是添加
                        this.dataChanage(URL.amountSetting.editRule, this.settingForm, res => {
                            this.loading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: "提交成功",
                                    type: "success",
                                    duration: 500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$emit("refreshDataList");
                                    }
                                });
                            } else {
                                this.$message.error("提交失败");
                            }
                            this.visible = false;
                        })
                    });
                },
                1000,
                {leading: true, trailing: false}
            ),
            addRules(type) {
                let rules = [];
                if (type == 0) {
                    rules = this.notActiveRule;
                } else{
                    rules = this.activeRule;
                }
                if (rules.length == 0){
                    this.addNum=0;
                }else {
                    this.addNum=this.addNum+1;
                }
                rules.push(
                    {activeStatus: type,
                     gt: 0,
                     lt:0,
                     amount:0,
                    index: this.addNum
                });
                this.addNum++;
            }
        }
    };
</script>
<style lang="scss" scoped>
  .condition-title {
    ul {
      display: flex;
      padding: 20px 0;

      li {
        width: 180px;
        text-align: center;
        margin-right: 20px;
      }
    }
  }

  ul,
  li {
    list-style: none;
  }
</style>
